import BlogList from '../views/blog/list/BlogList';
import BlogSingle from '../views/blog/single/BlogSingle';
import Home from '../views/home/Home';
import LeadershipList from '../views/leadership/LeadershipList';
import LeadershipDetail from '../views/leadership/LeadershipDetail';
import DestinationAreaList from '../views/destination/list/DestinationAreaList';
import Place from '../views/destination/place/Place';
import SingleService from '../views/destination/service/SingleService';
import DestinationArea from '../views/destination/areaDetail/DestinationArea';
import About from '../views/about/About';
import ActivityList from '../views/activity/ActivityList';
import ActivityDetail from '../views/activity/ActivityDetail';
import SpecialList from '../views/special/SpecialList';
import SpecialDetail from '../views/special/SpecialDetail';
import PortfolioList from '../views/portfolio/PortfolioList';
import Agency from '../views/agency/Agency';
import { exact } from 'prop-types';
import SearchList from '../views/search/SearchList';

export const routes = [
    { path: "/home", component: Home },
    { path: "/revolution", component: LeadershipList,  exact },
    { path: "/revolution/:id", component: LeadershipDetail, exact },

    { path: "/destination", component: DestinationAreaList, exact },
    { path: "/destination/:id", component: DestinationArea, exact },
    { path: "/destination/:id/:position", component: DestinationArea, exact },
    { path: "/place/:place_id", component: Place, exact },
    { path: "/service/:service_id", component: SingleService, exact },

    { path: "/special", component: SpecialList, exact },
    { path: "/special/:id", component: SpecialDetail, exact },
    { path: "/activity", component: ActivityList, exact },
    { path: "/activity/:id", component: ActivityDetail, exact },

    { path: "/blog", component: BlogList, exact },
    { path: "/blog/:business", component: BlogList, exact },
    { path: "/blog/:business/:id", component: BlogSingle, exact },

    { path: "/portfolio", component: PortfolioList },
    { path: "/about", component: About },

    { path: "/agency/:id", component: Agency, exact },
    { path: "/search", component: SearchList, exact }
];